export const deleteSpaces = array => array.map(elem => elem.trim())